export var CHOICE_TYPE = 'Choice';
export var TEXT_ANSWER_TYPE = 'TextAnswer';
export var NUMERIC_ANSWER_TYPE = 'NumericAnswer';
export var FILE_UPLOAD_TYPE = 'FileUpload';
export var RATING_TYPE = 'Rating';
export var ADDRESS_CHECKER_TYPE = 'AddressChecker';
export var SELECT_TYPE = 'Select';
export var MESSAGE = 'Message';
export var MAX_RESPONSE_LENGTH = 500;
export var MAX_FILE_UPLOAD = 5;
export var SURVEY_OPTIONS = [{
  displayName: 'Choice',
  componentType: CHOICE_TYPE
}, {
  displayName: 'Text Answer',
  componentType: TEXT_ANSWER_TYPE
}, {
  displayName: 'File Upload',
  componentType: FILE_UPLOAD_TYPE
}, {
  displayName: 'Rating',
  componentType: RATING_TYPE
}];
export var optionTypes = {
  checkbox: 'checkbox',
  textInput: 'textInput',
  radioButton: 'radioButton'
};
export var questionStates = {
  new: 'new',
  committed: 'committed'
};
export var moveDirections = {
  up: 'up',
  down: 'down'
};
export var ICONS = Object.freeze({
  INFO_CIRCLE: 'InfoCircle',
  ERROR_CIRCLE: 'ErrorCircle'
});
export var getResponseCharCountColor = function getResponseCharCountColor(length) {
  if (MAX_RESPONSE_LENGTH - length === 0) return '#d50000';
  if (MAX_RESPONSE_LENGTH - length <= 50) return '#f06c00';
  return '#404040';
};
export var QUESTION_BUILDER_VALIDATION_TITLE_NO_VALUE = 'Please provide the question you would like colleagues to answer.';
export var QUESTION_BUILDER_VALIDATION_CHOICE_NONE = 'Please provide at least one option.';
export var QUESTION_BUILDER_VALIDATION_CHOICE_NO_VALUE = 'Please provide an option.';
export var CHOICE_TYPE_ERROR = 'Please select an option for this question';
export var FILE_UPLOAD_TYPE_ERROR = 'Please upload an image for this question';
export var RATING_TYPE_ERROR = 'Please select an option for this question';
export var TEXT_ANSWER_TYPE_ERROR = 'Please enter a response for this question';
export var NUMERIC_ANSWER_TYPE_ERROR = function NUMERIC_ANSWER_TYPE_ERROR(min, max) {
  return "Please enter a valid response between ".concat(min, " to ").concat(max, " for this question");
};
export var SELECT_TYPE_ERROR = 'Please select an option for this question';
export var SURVEY_EXPORT_FILE_COLUMNS = ['Store Code', 'Viewed On', 'Viewed By Name', 'Completed On', 'Completed By Name'];
/** Legacy constants */

export var QUESTION_TYPE_TEXTAREA = 'TextArea';
export var QUESTION_TYPE_IMAGE = 'Image';
export var QUESTION_TYPE_RADIO_BUTTON = 'RadioButtonQuestion';
export var QUESTION_TYPE_IMAGE_SELECTION = 'ImageSelectionQuestion';
export var QUESTION_TYPE_IMAGE_SELECTION_BUILDER = 'ImageSelectionQuestionBuilder';
export var QUESTION_TYPE_ADDRESS_CHECKER = 'AddressChecker';
export var VALIDATION_ERROR = 'Answer is required';
export var NONE_OF_THE_ABOVE_TITLE = 'None of the above';
export var FILE_TYPE_IMAGE_PNG = 'image/png';
export var FILE_TYPE_IMAGE_JPEG = 'image/jpeg';
export var FILE_TYPE_IMAGE_JPG = 'image/jpg';
export var FILE_TYPE_IMAGE_GIF = 'image/gif';
export var MAX_FILE_SIZE_BYTES = 8000000;